// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".viewList{list-style:none none;padding:0}.viewList li{margin:0 30px 15px 0;max-width:200px;vertical-align:top;display:inline-block;padding:0}.viewList li a{font-size:0.8em;font-weight:bold;color:#333}.viewList li img{width:200px;height:200px;border:1px solid #dfdfdf}\n", ""]);
// Exports
module.exports = exports;
